<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.666504 8.66675L4.6665 4.66675L0.666504 0.666748" stroke="#E5E5E5" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
